// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-project-project-pagination----project-pagination-module---wrapper---2rYLZ","content":"src-components-project-project-pagination----project-pagination-module---content---1BtoB","title":"src-components-project-project-pagination----project-pagination-module---title---3-5m-","headline":"src-components-project-project-pagination----project-pagination-module---headline---18BrZ","arrow":"src-components-project-project-pagination----project-pagination-module---arrow---5Omg0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/project/project-pagination/project-pagination.module.css
// module id = 529
// module chunks = 140935043865547